<template>
  <div>
    <!-- 注册表单 -->
    <el-form
      ref="registerForm"
      :rules="registerRules"
      :model="registerForm"
      class="form register-form"
      label-position="top"
      hide-required-asterisk
    >
      <!-- 手机号 -->
      <el-form-item prop="mobile" label="手机号码（登录账号）">
        <el-input
          v-model.trim="registerForm.mobile"
          placeholder="请输入你的手机号码作为登录账号"
          size="medium"
        />
      </el-form-item>
      <!-- 密码 -->
      <el-form-item prop="password" label="登录密码">
        <el-input
          v-model.trim="registerForm.password"
          placeholder="请输入密码"
          size="medium"
          show-password
        />
      </el-form-item>
      <!-- 再次输入密码 -->
      <el-form-item prop="confirmPassword" label="再次确认密码">
        <el-input
          v-model.trim="registerForm.confirmPassword"
          placeholder="请再次输入密码"
          size="medium"
          show-password
        />
      </el-form-item>
      <!-- 短信验证码 -->
      <el-form-item prop="smsCode" label="短信验证码">
        <div class="flex">
          <el-input
            v-model.trim="registerForm.smsCode"
            class="item-left flex-1"
            placeholder="请输入验证码"
            size="medium"
          />
          <count-down-button
            ref="countDown"
            :max-count="60"
            :btn-height="32"
            :mobile="registerForm.mobile"
            :graphic-code="registerForm.graphicCode"
            style="margin-left: 1rem"
            :template-code="templateCodeObj.register"
            @click.native="handleCountDown"
            @getSmsToken="data => (registerForm.smsToken = data.token)"
          />
        </div>
      </el-form-item>
      <el-form-item class="m-b-0">
        <div class="register-agreement">
          <el-checkbox v-model="agree" class="m-r-10" />
          <div>
            我已阅读并同意
            <span class="agreement-button">
              <el-button
                type="text"
                @click="userAgreementDialog = true"
              >用户注册协议</el-button>
            </span>
            <span class="agreement-button">
              <el-button
                type="text"
                @click="privacyPolicyDialog = true"
              >平台隐私策略</el-button>
            </span>
            <span class="agreement-button">
              <el-button
                type="text"
                @click="goodFaithBookDialog = true"
              >诚信廉洁承诺</el-button>
            </span>
          </div>
        </div>
      </el-form-item>
      <!-- 注册按钮 -->
      <el-form-item class="m-t-24">
        <el-button
          class="one-line"
          :loading="loading"
          type="primary"
          size="medium"
          @click="onRegister"
        >
          立即注册
        </el-button>
      </el-form-item>
    </el-form>

    <!-- 协议弹窗组件 -->
    <user-agreement v-model="userAgreementDialog" />
    <privacy-policy v-model="privacyPolicyDialog" />
    <good-faith-book v-model="goodFaithBookDialog" />
  </div>
</template>

<script>
import CountDownButton from '@/components/CountDownButton'
import UserAgreement from '@/components/AgreementText/UserAgreement'
import PrivacyPolicy from '@/components/AgreementText/PrivacyPolicy'
import GoodFaithBook from '@/components/AgreementText/GoodFaithBook'

// 后端api接口
import { searchIfMobileOccupiedApi, registerApi } from '@/api/user.js'

// 数据字典
import { templateCodeObj } from '@/dictionary'
import {
  emailRegularValid,
  mobileRegularValid,
  passwordRegularValid
} from '@/utils/form-valid'

export default {
  name: 'EmployeeRegister',

  components: {
    CountDownButton,
    UserAgreement,
    PrivacyPolicy,
    GoodFaithBook
  },

  data() {
    return {
      returnUrl: this.$route.query.returnUrl,

      templateCodeObj: templateCodeObj,
      registerForm: {
        password: '', // 密码
        confirmPassword: '', // 再次输入确认密码
        mobile: '', // 手机号（登录账号）
        smsCode: '', // 验证码
        smsToken: '',
        email: ''
      },
      registerRules: {
        email: [
          {
            required: true,
            message: '邮箱不能为空',
            trigger: ['blur', 'change']
          },
          emailRegularValid
        ],
        password: [
          {
            required: true,
            message: '密码不能为空',
            trigger: ['blur', 'change']
          },
          passwordRegularValid
        ],
        confirmPassword: [
          {
            validator: this.validateConfirmPassword,
            trigger: 'blur'
          }
        ],
        mobile: [
          {
            required: true,
            message: '手机号不能为空',
            trigger: ['blur', 'change']
          },
          mobileRegularValid,
          {
            validator: this.validateMobile,
            trigger: ['blur']
          }
        ],
        smsCode: [
          {
            required: true,
            message: '短信验证码不能为空',
            trigger: ['blur', 'change']
          }
        ],
        identity: [
          {
            required: true,
            message: '请选择您注册的用户类型',
            trigger: ['blur', 'change']
          }
        ]
      },
      loading: false,
      agree: false, // 是否勾选注册协议

      privacyPolicyDialog: false, // 隐私政策弹窗
      userAgreementDialog: false, // 用户注册协议
      goodFaithBookDialog: false // 诚信廉洁承诺
    }
  },

  methods: {
    // 再次输入密码校验
    validateConfirmPassword(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    },

    // 手机号是否已注册校验
    validateMobile(rule, value, callback) {
      if (!value) {
        return callback()
      }

      searchIfMobileOccupiedApi({ mobile: value })
        .then(res => {
          if (res.data) {
            callback(new Error('当前手机号已被注册'))
          } else {
            callback()
          }
        })
        .catch(err => {
          callback(new Error(err.data.message))
        })
    },

    // 返回
    onGoBack() {
      this.$router.back()
    },

    // 注册
    onRegister() {
      this.$refs.registerForm.validate(valid => {
        if (!valid) return

        if (!this.agree) {
          this.$message.warning('请先阅读《用户注册协议》并同意')
          return
        }

        this.loading = true
        registerApi(this.registerForm)
          .then(res => {
            this.loading = false
            this.$message.success('用户注册成功')

            setTimeout(() => {
              this.$router.push({
                name: 'SelectService',
                params: { new: 'new' }
              })
            }, 3000)
          })
          .catch(err => {
            this.loading = false
            this.$message.error(err.data.message)
          })
      })
    },

    // 点击验证码获取按钮
    handleCountDown() {
      this.$refs.registerForm.validateField('mobile', fail => {
        if (!fail) {
          this.$refs.countDown.showDialog()
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.register-agreement {
  display: flex;

  .agreement-button {
    display: inline-block;

    &::before {
      content: '《';
      color: $primary-color;
    }
    &::after {
      content: '》';
      color: $primary-color;
    }
    ::v-deep .el-button {
      padding: 0;
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    margin-bottom: 24px;

    .el-form-item__label {
      padding: 0;
      color: $text-color;
    }
    .el-input input {
      height: 32px;
    }
  }
}
</style>
